export default __webpack_public_path__ + "static/construction-bg-8507b2bc38aabc008b3701a292ee5585.jpg";